import { ReactNode } from 'react';

import {
  BundlesLayout,
  createGradientOrSolid,
  EBundlesViewModel,
  EFontWeights,
  ProgressBarDesign
} from '@appcharge/shared-ui';
import {
  EBundlesInternalViewModel,
  ESpecialOfferInternalViewModel
} from 'constants/enums';
import { renderingUtil } from 'utils/renderingUtil';
import {
  MOCK_PRICES,
  MOCK_PROGRESS_BAR_PRODUCTS,
  PROGRESS_BAR_DEFAULTS,
  PROGRESS_BAR_PREVIEW_DEFAULTS,
  PROMOTION_DEFAULTS
} from 'views/OfferDesign/OfferDesign.consts';
import { RenderCardFn } from 'views/OfferDesign/OfferDesign.types';
import { normalizeBgColor } from 'views/OfferDesign/OfferDesign.utils';

export const applyCssVariables = (
  el: HTMLDivElement,
  storeScreen: any,
  font: string
) => {
  el.style.setProperty('--button-text-color', storeScreen.buttonTextColor || '');
  el.style.setProperty('--button-bg-color', createGradientOrSolid(storeScreen.buttonColor) || '');
  el.style.setProperty('--font-family', font || '');
};

export const clearCssVariables = (el: HTMLDivElement) => {
  el.style.removeProperty('--button-text-color');
  el.style.removeProperty('--button-bg-color');
  el.style.removeProperty('--font-family');
};

export const renderBundleCard = (
  values: Record<string, any>,
  generalTheme: any,
  storeScreen: any
): ReactNode => {
  const viewModel = generalTheme.bundlesViewModel as EBundlesViewModel;
  const internalModel = generalTheme.bundlesInternalViewModel || EBundlesInternalViewModel.MAIN_SUB;

  return (
    <BundlesLayout bundlesViewModel={viewModel} isPreview>
      {renderingUtil.renderBundleByInternalModel(internalModel, {
        index: 0,
        ...(values.backgroundImage && { backgroundSrc: values.backgroundImage }),
        ...(values.backgroundColor && { backgroundColor: normalizeBgColor(values.backgroundColor) }),
        bundleBorderColor: storeScreen.bundleBorderColor,
        productList: [],
        bundleButtonColor: storeScreen.buttonColor,
        bundleButtonTextColor: storeScreen.buttonTextColor,
        fontFamily: generalTheme.font,
        prices: MOCK_PRICES,
        inMobileMock: true,
        gameName: internalModel
      })}
    </BundlesLayout>
  );
};

export const renderPromotionCard = (
  values: Record<string, any>,
  generalTheme: any,
  storeScreen: any
): ReactNode => {
  const internalModel =
    generalTheme.specialOffersInternalViewModel ||
    ESpecialOfferInternalViewModel.HUGE;

  return renderingUtil.renderSpecialOfferByInternalModel(internalModel, {
    title: values.title || '',
    fontSize: values.fontSize || PROMOTION_DEFAULTS.fontSize,
    fontWeight: (values.fontWeight || PROMOTION_DEFAULTS.fontWeight) as EFontWeights,
    textColor: values.fontColor || PROMOTION_DEFAULTS.fontColor,
    subTitle: values.subTitleText || '',
    subTitleSize: values.subTitleFontSize || PROMOTION_DEFAULTS.subFontSize,
    subTitleWeight: (values.subTitleFontWeight || PROMOTION_DEFAULTS.fontWeight) as EFontWeights,
    subTitleColor: values.subTitleFontColor || PROMOTION_DEFAULTS.fontColor,
    ...(values.backgroundImage && { backgroundImage: values.backgroundImage }),
    ...(values.backgroundColor && { backgroundColor: normalizeBgColor(values.backgroundColor) }),
    borderColor: storeScreen.bundleBorderColor,
    buttonColor: storeScreen.buttonColor,
    design: 'match',
    prices: MOCK_PRICES,
    productsList: [],
    selectOffer: () => {},
    collectText: values.collectText || PROMOTION_DEFAULTS.collectText
  });
};

export const renderProgressBarCard: RenderCardFn = (values) => {
  return (
    <ProgressBarDesign
      offerId="preview"
      backgroundOpacity={Number(values.backgroundOpacity) ?? PROGRESS_BAR_DEFAULTS.backgroundOpacity}
      frameRadius={Number(values.frameRadius) ?? PROGRESS_BAR_DEFAULTS.frameRadius}
      barFillColor={normalizeBgColor(values.barFillColor) || PROGRESS_BAR_DEFAULTS.barFillColor}
      backgroundColor={normalizeBgColor(values.barBackgroundColor) || PROGRESS_BAR_DEFAULTS.backgroundColor}
      barRadius={Number(values.barRadius) ?? PROGRESS_BAR_DEFAULTS.barRadius}
      borderColor={normalizeBgColor(values.borderColor) || PROGRESS_BAR_DEFAULTS.borderColor}
      borderWidth={Number(values.borderWidth) ?? PROGRESS_BAR_DEFAULTS.borderWidth}
      accumulatedItemUrl={values.accumulatedItemImageUrl || ''}
      textColor={values.textColor || PROGRESS_BAR_DEFAULTS.textColor}
      progressBarProducts={MOCK_PROGRESS_BAR_PRODUCTS}
      collectedPoints={PROGRESS_BAR_PREVIEW_DEFAULTS.collectedPoints}
      isPreview
      activeMissionIndex={PROGRESS_BAR_PREVIEW_DEFAULTS.activeMissionIndex}
      missionsLength={PROGRESS_BAR_PREVIEW_DEFAULTS.missionsLength}
    />
  );
};

